<template>
	<div class="page">
		<!-- <Tip :tip="tip" /> -->
		<div style="margin-bottom: 10px;">
            <el-input placeholder="模板名称" v-model="screen.template_name" clearable size="small" style="width: 200px;"/>
            <el-button size="small" style="margin-left: 10px;" @click="getOaTemplateList(1)">筛选</el-button>
			<el-button size="small" type="success" v-permit="'/admin/oa/templateAdd'" @click="edit(0)">+新增模板</el-button>
		</div>
        <el-table :data="tableData" v-loading="loading" :header-cell-style="tabStyle">
            <el-table-column label="编号" prop="template_id" width="80" />
            <el-table-column label="模板名称" prop="template_name" />
            <el-table-column label="创建人" align="center" prop="created_time">
                <template slot-scope="{row}">
                    {{row.admin ? row.admin.nick_name : ''}} {{row.admin && row.admin.phone ? row.admin.phone.slice(-4) : ''}}
                </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center" prop="created_time"></el-table-column>
            <el-table-column label="申请数" align="center" prop="template_applys" width="80px" />
            <el-table-column label="排序" prop="template_sort" width="80px" />
            <el-table-column label="状态" align="center" prop="state_text" width="80px">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.state" :active-value="1" :inactive-value="0" :disabled="!checkAuth('/admin/oa/templateDisable')" @change="disable($event, scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="350">
                <template slot-scope="{row}">
                    <el-button size="mini" type="primary" @click="edit(row.template_id)">编辑</el-button>
                    <el-button size="mini" type="success" @click="process(row.template_id, row.template_table)" :loading="loadingBtn == row.template_id">流程</el-button>
                    <el-popconfirm title="确定删除吗？" @confirm="operate(row.template_id,1)">
                        <el-button slot="reference" size="mini" type="danger">删除</el-button>
                    </el-popconfirm>
                    <el-button size="mini" type="info" @click="runTo(row.template_id)">记录</el-button>
                    <!-- <el-button size="mini" type="primary">提审</el-button> -->
                </template>
            </el-table-column>
        </el-table>
		<!--弹出层-->
		<!-- <Popup :name="name" :show="show" :type="template_id" @close='close' /> -->

        <el-dialog :title="form.template_id > 0 ? '编辑模板' : '新增模板'" :visible.sync="show" center width="800px">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="名称：">
                    <el-input placeholder="请输入名称" v-model="form.template_name"/>
                </el-form-item>
                <el-form-item label="排序：">
                    <el-input-number v-model="form.template_sort" :min="1" :max="100" label="" />
                </el-form-item>
                <el-form-item label="部门：" prop="depart_id">
                    <el-cascader v-model="form.depart_id" clearable :options="departArr" :props="{value:'id',label:'name',checkStrictly:false,multiple:true}" style="width: 100%;"></el-cascader>
                </el-form-item>
				<el-form-item label="适用表单：">
                    <el-tabs v-model="form.template_type">
                        <el-tab-pane label="系统表单" name="1">
                            <div style="display: grid;grid-template-columns: repeat(3, 1fr);gap: 10px;">
                                <el-radio v-model="form.template_table" v-for="(item, index) in type1Arr" :key="item.name" :label="item.name" border :style="{marginLeft: index % 3 == 0 ? '0px' : '10px'}">{{item.comment}}</el-radio>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="自建表单" name="2">
                            <div style="display: grid;grid-template-columns: repeat(3, 1fr);gap: 10px;">
                                <el-radio v-model="form.template_table" v-for="(item, index) in type2Arr" :key="item.name" :label="item.name" border :style="{marginLeft: index % 3 == 0 ? '0px' : '10px'}">{{item.comment}}</el-radio>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="submitTemplate">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="流程设置" :visible.sync="processvisible" center width="1000px" destroy-on-close>
            <div style="display: flex;">
				<div style="width: 50%;">
                    <el-scrollbar style="height: 60vh;">
                        <h4>审批流程图：</h4>
                        <div class="left_div">
                            <span class="item_div">创建申请</span>
                            <div class="item_pro">
                                <span class="span_icon">|</span>
                                <i class="el-icon-circle-plus" style="cursor: pointer;" @click="addItem(0)"></i>
                                <i class="el-icon-bottom"></i>
                            </div>
                            <div v-if="proList.length > 0" class="left_div" v-for="(item,index) in proList" :key="index">
                                <div class="left_item_div" @click="editItem(index)">
                                    <div class="type_div">
                                        <span>{{item.node_name}}</span>
                                        <i class="el-icon-delete" @click.stop="deleteItem(index)"></i>
                                    </div>
                                    <span class="name_div" v-if="item.checker_type == 1">指定成员</span>
                                    <span class="name_div" v-if="item.checker_type == 2">直属部门负责人</span>
                                    <span class="name_div" v-if="item.checker_type == 3">申请人本人</span>
                                </div>
                                <div class="item_pro">
                                    <span class="span_icon">|</span>
                                    <i class="el-icon-circle-plus" style="cursor: pointer;" @click="addItem(index+1)"></i>
                                    <i class="el-icon-bottom"></i>
                                </div>
                            </div>
                            <span class="item_div">流程结束</span>
                        </div>
                    </el-scrollbar>
				</div>
            
				<div v-if="selectIndex != -1 && proList && proList.length" style="width: 50%;">
                    <el-scrollbar style="height: 60vh;">
                        <h4>流程节点设置：</h4>
                        <div>当前审核人拒绝本次申请时，记录退回上一审核人。</div>
                        <div style="margin-top: 20px;display: flex;align-items: center;">
                            <div style="width: 60px;">名称：</div>
                            <el-input placeholder="请填写审批名称" v-model="proList[selectIndex].node_name" clearable style="width: 300px;" />
                        </div>
                        <div style="display: flex;flex-direction: column;">
                            <div style="margin-top: 20px;display: flex;">
                                <div style="width: 60px;">审批人：</div>
                                <el-radio-group v-model="proList[selectIndex].checker_type">
                                    <el-radio :label="1">指定成员</el-radio>
                                    <el-radio :label="2">直属部门负责人</el-radio>
                                    <el-radio :label="3">申请人本人</el-radio>
                                </el-radio-group>
                            </div>
                            <el-select 
                                v-if="proList[selectIndex].checker_type == 1" 
                                v-model="proList[selectIndex].node_admin_id"
                                multiple clearable placeholder="请选择审批人" style="margin-top: 20px;margin-left: 60px;width: 350px;" @change="selectChange"
                            >
                                <el-option v-for="item in adminArr" :key="item.admin_id" :label="item.nick_name" :value="item.admin_id + ''" />
                            </el-select>
                        </div>
                        <div style="display: flex;flex-direction: column;">
                            <div style="margin-top: 20px;margin-bottom: 20px;">节点权限设置：</div>
                            <el-table :data="proList[selectIndex].node_permit" stripe :header-cell-style="{ background:'#f5f5f5'}">
                                <el-table-column prop="sort" label="排序">
                                    <template v-slot="{row}">
                                        <el-input-number v-model="row.sort" controls-position="right" :min="1" :max="100" style="width: 100px;" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="title" label="字段" />
                                <el-table-column prop="view" label="可见">
                                    <template v-slot="{row}">
                                        <el-switch v-model="row.view" active-value="1" inactive-value="0"></el-switch>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="edit" label="可编辑">
                                    <template v-slot="{row}">
                                        <el-switch v-model="row.edit" active-value="1" inactive-value="0"></el-switch>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-scrollbar>
				</div>
			</div>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="processvisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>

		<div class="foot_div">
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "@/components/Tip/Tip.vue"
	import Popup from "@/components/Popup/Popup.vue"
	import { oaTemplate, DepartmentLists, tableLists, adminLists, flowDetail, flowEdit, fieldLists } from "@/request/apis.js"
	export default {
		components: { Tip, Popup },
		data() {
			return {
				tip: '企业日常事项审批流程的模板管理。',
				template_id: -1, //模板id
				screen: {
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
                    template_name: '',
				},
                loading: false,
				tableData: [],
				total: 0, //总条数
				name: '',
				show: false,
                formInit: {},
                form: {
                    template_id: '',
					template_name: '', //模板名称
					template_sort: 1, //展示排序
					template_type: '1', //适用表单:1=关联业务表单,2=自定义表单
					template_relate: [], //关联业务表单
					template_form: [], //自定义表单
                    depart_id: [],
                    template_table: '',
				},
                departArr: [],
                type1Arr: [],
                type2Arr: [],
                processvisible: false,
                adminArr: [],
                proList: [],
                selectIndex: 0,
                current_template_id: 0,
                fieldArr: [],
                loadingBtn: 0,
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
            this.formInit = {...this.form};
			this.getOaTemplateList();
		},
		methods: {
			getOaTemplateList() {
                this.loading = true;
				oaTemplate({ ...this.screen }, 4).then(res => {
                    this.loading = false;
					if (res.code === 0) {
						this.total = res.count;
						this.tableData = res.data;
					}else{
                        return this.$message.error(res.msg || '操作失败')
                    }
				}).catch(err => {})
			},

			//点击按钮切换页面
			handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getOaTemplateList();
			},

			//模板启用&停用
			operate(template_id,type) {
				oaTemplate({
					template_id: template_id
				}, type).then(res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.handleCurrentChange(this.screen.page);
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

            disable(newState, row){
                var desc = newState == 1 ? '启用' : '禁用';
                this.$confirm('此操作将' + desc +  '当前模板, 是否继续?', desc, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let res = await oaTemplate({ template_id: row.template_id }, 5);
                    if (res.code !== 0) {
                        row.state = newState == 1 ? 2 : 1;
                        return this.$message.error(res.msg || '操作失败')
                    }
                    this.$message({ message: res.msg || '操作成功', type: 'success' });
                    this.getOaTemplateList();
                }).catch(() => {row.state = newState == 1 ? 2 : 1;});
            },
            getOaTemplateDetail(template_id) {
				oaTemplate({ template_id }, 3).then(res => {
					if(res.code == 0){
						res.data.template_form.forEach(item=>{
							item.requierd = Boolean(item.requierd)
						})
						res.data.template_relate = res.data.template_relate.map(Number)
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
                        this.form.template_type = res.data.template_type + '';
						this.tempName = res.data.template_name;
						this.moduleList = this.form.template_form.length > 0 ? this.form.template_form : TemplateList.TemplateList
					}
				}).catch(err=>{})
			},
            edit(template_id = 0){
                if(template_id){
                    this.getOaTemplateDetail(template_id);
                }else{
                    this.form = {...this.formInit};
                }
                this.getDepartmentLists();
                this.getTableLists();
                this.show = true;
            },
            submitTemplate(){
				var type = this.form.template_id > 0 ? 2 : 0;
				oaTemplate({ ...this.form }, type).then(res => {
					if (res.code == 0) {
                        this.show = false;
						this.getOaTemplateList();
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
            },
            async getDepartmentLists(){
                var res = await DepartmentLists();
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.departArr = res.data;
            },
            async getTableLists(){
                var res = await tableLists({oa: 1});
                if (res.code !== 0) {
                    return this.$message.error(res.msg);
                }
                this.type1Arr = [];
                this.type2Arr = [];
                res.data.tables.forEach(ele => {
                    if(ele.is_customize == 1){
                        this.type2Arr.push(ele);
                    }else{
                        this.type1Arr.push(ele);
                    }
                });
                console.log(this.type1Arr, this.type2Arr)
            },

            open(type, template_id) {
				this.template_id = template_id;
				this.name = type == 0 ? 'approvalTemplateEdit' : 'ProcessSet';
				this.show = true
			},

			runTo(template_id) {
				this.$router.push('/initiateRecord?template_id=' + template_id);
			},

			close(type) {
				if (type == 0) {
					this.handleCurrentChange(this.screen.page);
				}
				this.show = false
			},


            async process(template_id, table){
                this.current_template_id = template_id;
                this.getadminArr();
                this.loadingBtn = template_id;
                await this.getOaFlowDetail(table);
                this.loadingBtn = 0;
                this.processvisible = true;
            },
            //获取角色列表
			getadminArr() {
				adminLists({ limit: 1000 }).then(res => {
					if (res.code == 0) {
						this.total = res.count;
						this.adminArr = res.data;
					}
				}).catch(err => {})
			},

			//获取审批流程详情
			async getOaFlowDetail(table) {
                this.proList = [];
				let res = await flowDetail({ template_id: this.current_template_id }, 0);
                if (res.code == 0) {
                    if(res.data.length > 0){
                        res.data.forEach((item,index)=>{
                            var obj = {
                                node_name: item.node_name,
                                node_admin_id: item.node_admin_id || [],
                                admin_name: item.admin ? item.admin.nick_name : '',
                                checker_type: item.checker_type,
                                node_permit: item.node_permit,
                            }
                            this.proList.push(obj)
                        })
                    }
                }
                this.getFieldLists(table);
			},

            async getFieldLists(table){
                var res = await fieldLists({table, filter: 'customize'});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.fieldArr = res.data;
            },
			
			//下拉选择器
			selectChange(val){
				var index = this.adminArr.findIndex(item => item.admin_id === val);
				this.proList[this.selectIndex].admin_name = this.adminArr[index].nick_name
			},

			confirm() {
				flowEdit({ template_id: this.current_template_id, nodes:this.proList }, 1).then(res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
                        this.processvisible = false;
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			//添加节点
			addItem(index) {
                let node_permit = [];
                this.fieldArr.forEach(ele => {
                    node_permit.push({name: ele.name, title: ele.title, sort: ele.sort, view: '0', edit: '0'});
                });
				var obj = {
					node_name: '审批名称',
					node_admin_id: [],
					admin_name:'审批人',
                    checker_type: 1,
                    node_permit,
				}
				this.proList.splice(index, 0, obj)
			},

			//移除节点
			deleteItem(index) {
				this.proList.splice(index, 1)
				this.selectIndex = 0;
			},

			//编辑节点信息
			editItem(index) {
				this.selectIndex = index;
                console.log('editItem', index, this.selectIndex)
			},
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		padding: 10px 20px 0 20px;
		min-height: -webkit-fill-available;
	}

	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.screen_btn {
		margin-left: 13px;
	}

	.el-button--mini {
		margin-right: 10px;
	}

	.item_btn {
		margin: 0 5px 0 0;
	}

	/*伪类样式*/
	.item_btn:nth-child(5) {
		margin-top: 5px;
	}

	.foot_div {
		position: absolute;
		display: flex;
		flex-direction: row-reverse;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	.pagination {
		display: flex;
		padding: 20px 30px 20px 30px
	}

	.el-dropdown-link {
		padding: 15px 5px;
		cursor: pointer;
		color: #fff;
	}

	.dropdown-menu {
		margin-bottom: 25px !important;
	}


    .left_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 300px;
	}

	.item_div {
		width: 200px;
		text-align: center;
		font-size: 14px;
		color: #767676;
		padding: 15px 0;
		border: 1px solid #767676;
		border-radius: 5px;
		margin: 10px 0;
	}

	.left_item_div {
		width: 200px;
		display: flex;
		flex-direction: column;
		text-align: center;
		border: 1px solid #0256FF;
		border-radius: 5px;
		margin: 10px 0
	}

	.type_div {
		width: 100%;
		height: 26px;
		padding: 5px 0;
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		background: rgba(2, 86, 255, 0.2);
		font-size: 14px;
		color: #000;
	}

	.el-icon-delete {
		position: absolute;
		right: 10px;
		font-size: 20px;
		color: #EA0000;
	}

	.name_div {
		height: 26px;
		font-size: 14px;
		color: #000;
		padding: 10px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.item_pro {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.span_icon {
		display: flex;
		justify-content: center;
		font-size: 15px;
		color: #767676;
	}

	.el-icon-circle-plus {
		font-size: 20px;
		margin: 5px 0 2px 0;
		color: #00A292
	}

	.el-icon-bottom {
		font-size: 20px;
		color: #767676;
	}

	.right_div {
		display: flex;
		flex-direction: row;
		margin: 30px 0 0 30px;
		font-size: 14px;
		color: #000;
		align-items: center;
	}
    /deep/.el-scrollbar .el-scrollbar__wrap { overflow-x: hidden; }
</style>